import styled from 'styled-components';

export const MapTypeButtons = styled.div`
  margin-bottom: -32px;
  margin-right: var(--size-lg);

  .ant-tabs-nav {
    margin-bottom: 0px;
  }

  .ant-tabs-tab {
    color: #262626;
    font-weight: 500;
  }
`;
